import LinkIcon from '@mui/icons-material/LinkOutlined';
import CopyToClipboard from 'react-copy-to-clipboard';
import CopyIcon from '../../../../../assets/icons/copy.svg?url';
import l from '../../../../../lang';
import Input from '../../../../common/input';
import ButtonCustom from '../../../../common/__deprecated__/button-custom';
import ShareButtons from './share-buttons';
import './styles.scss';
import { segmentShareAffiliateLink } from '../../../../../utils/analytics';
import { useDashboard } from '../../../../../store/dashboard';

interface ShareLinkProps {
  url: string;
  onCopy?: () => void;
  validReferrer?: boolean;
}

const ShareLink = ({ url, onCopy, validReferrer }: ShareLinkProps) => {
  const { merchantMe, userMe } = useDashboard();

  const handleCopy = () => {
    if (onCopy) {
      onCopy();
    }
    if (!merchantMe || !userMe) return;

    segmentShareAffiliateLink({
      channel: 'copy',
      valid: validReferrer ? 1 : 0,
      merchantId: merchantMe.id,
      userId: userMe.id,
    });
  };

  return (
    <div className="share_aff_link">
      <div className="share_aff_link__subheadline">{l('paymentLink.shareLink.subheadline1')}</div>
      <ShareButtons onCopy={onCopy} validReferrer={!!validReferrer} link={url} />
      <div className="share_aff_link__link">
        <div className="input">
          <Input name="copyLink" value={url} prefix={<LinkIcon color="primary" />} readOnly disabled />
        </div>
        <CopyToClipboard text={url} onCopy={() => handleCopy()}>
          <ButtonCustom
            name="btn-confirm"
            text={l('paymentLink.shareLink.copyLink')}
            color="primary"
            variant="contained"
            startIcon={<img className="share_aff_link__img_copy" src={CopyIcon} />}
          />
        </CopyToClipboard>
      </div>
    </div>
  );
};

export default ShareLink;
